module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stepThree"
  }, [_c('headers'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('steps', {
    attrs: {
      "step-num": 2
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "stepThree-form"
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 0
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "password": "",
      "placeholder": "请输入新密码"
    },
    model: {
      value: (_vm.formValidate.password),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "password", $$v)
      },
      expression: "formValidate.password"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "passwords"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "password": "",
      "placeholder": "请确认新密码"
    },
    model: {
      value: (_vm.formValidate.passwords),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "passwords", $$v)
      },
      expression: "formValidate.passwords"
    }
  })], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formValidate')
      }
    }
  }, [_vm._v("下一步")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b3dd676!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mobile/stepThree.vue
// module id = 191
// module chunks = 0